import { FunctionComponent } from 'react';

import SectionArticles from 'components/content/sections/Articles';
import { ArticleType } from 'components/content/sections/Articles/types';
import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PageArticleSectionHero: FunctionComponent<Props> = ({ translations, articles }) => {
    return (
        <StyledComponent className="page-article-section-articles">
            <LayoutContainer size={Sizes.XMedium}>
                <SectionArticles
                    articleType={ArticleType.List}
                    articles={articles}
                    translations={translations}
                />
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PageArticleSectionHero;
